// RITM1147493
import { TextInput,
	Button,
	Checkbox,
	RadioButtonGroup,
	FormGroup,
	RadioButton,
	ComposedModal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	DropdownSkeleton,
	MultiSelect, } from "carbon-components-react";
import React, { Component, useState , useEffect} from "react";
import { ComboBox } from "../../helpers/ComboBox";
import _sortBy from 'lodash/sortBy';
import { api, dynamic } from '../../helpers/api/api';
import {
	getSuccess,
	getError,
	apioperation
  } from '../../helpers/Constants';
import { showNotification } from "../../helpers/notification/BaseNotification";
import { DateFormat, entitiesLabels } from "../../helpers/Constants";
import PropTypes, { element } from "prop-types";
import HighConsequenceLevelLegend from "./HighConsequenceLevelLegend";

class IncidentHighConsequence extends Component {
	constructor(props){
		super(props);
		this.state = {
			/*NF ID: RITM1216061 || Task - 6 || Sub-Task-1  */
			// selectedRankingHighConsequenceLevelActualHarm:null,
			// selectedRankingHighConsequenceLevelActualWorstCaseHarm:null,
			// selectedRankingHighConsequenceLevelActualFinalHarm: null,
			// selectedRankingHighConsequenceLevelActualEnv:null,
			// selectedRankingHighConsequenceLevelActualWorstCaseEnv:null,
			// selectedRankingHighConsequenceLevelActualFinalEnv: null,
			// selectedPotentialFinalHarmIsValid: null,
			// selectedPotentialFinalEnvIsValid: null,
			/*RITM1216061 end*/
			appHighConsequenceLevelActualHarm: [],
			appHighConsequenceLevelPotentialWorstCaseHarm: [],
			appHighConsequenceLevelPotentialFinalHarm: [],
			appHighConsequenceLevelActualEnv: [],
			appHighConsequenceLevelPotentialWorstCaseEnv: [],
			appHighConsequenceLevelPotentialFinalEnv: [],
			appHighConsequenceLevelHarm: [],
			appIncidentEBarrierGroupHarm: [],
			appIncidentEBarrierGroupEnv: [],
			appIncidentIBarrierGroupHarm: [],
			appIncidentIBarrierGroupEnv: [],
			appIncidentEBarrierHarm: [],
			appIncidentEBarrierEnv: [],
			appIncidentIBarrierHarm: [],
			appIncidentIBarrierEnv: [],
			selectedItemsEBarrierGroupHarm: [],
			selectedItemsEBarrierGroupEnv: [],
			selectedItemsEBarrierHarm: [],
			selectedItemsEBarrierEnv: [],
			selectedItemsIBarrierGroupHarm: [],
			selectedItemsIBarrierGroupEnv: [],
			selectedItemsIBarrierHarm: [],
			selectedItemsIBarrierEnv: [],
			loading: false,
			incidentOutcomesEnums: props.incidentOutcomesEnums,
		}
	}

	async componentDidMount() {
		this.setState({loading: true})
		this.getIncidentHighConsequenceLevel(); //RITM1216061
		await this.getIncidentEBarrierGroup();
		await this.getIncidentIBarrierGroup();
		await this.getIncidentEBarrier();
		await this.getIncidentIBarrier();
		this.setState({
			selectedItemsEBarrierGroupHarm: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentEffectiveInadequateBarrierGroups?.filter((item) => item.idBarrier === 0)?.map((elem) => elem?.incidentBarrierGroup) || [],
			selectedItemsEBarrierGroupEnv: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentEffectiveInadequateBarrierGroups?.filter((item) => item.idBarrier === 0)?.map((elem) => elem?.incidentBarrierGroup) || [],
			selectedItemsEBarrierHarm: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((elem) => elem?.incidentBarrier) || [],
			selectedItemsEBarrierEnv: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((elem) => elem?.incidentBarrier) || [],

			selectedItemsIBarrierGroupHarm: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentEffectiveInadequateBarrierGroups?.filter((item) => item.idBarrier === 1)?.map((elem) => elem?.incidentBarrierGroup) || [],
			selectedItemsIBarrierGroupEnv: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentEffectiveInadequateBarrierGroups?.filter((item) => item.idBarrier === 1)?.map((elem) => elem?.incidentBarrierGroup) || [],
			selectedItemsIBarrierHarm: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((elem) => elem?.incidentBarrier) || [],
			selectedItemsIBarrierEnv: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((elem) => elem?.incidentBarrier) || [],
			loading: false})
			//await this.selectedPotentialFinal(); //RITM1216061
	}

	componentDidUpdate(prevProps) {
		console.log(this.props.outcomeModel)			
		if (prevProps.outcomeModel !== this.props.outcomeModel) {			
			this.setState({
			selectedItemsEBarrierGroupHarm: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentEffectiveInadequateBarrierGroups?.filter((item) => item.idBarrier === 0)?.map((elem) => elem?.incidentBarrierGroup) || [],
			selectedItemsEBarrierGroupEnv: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentEffectiveInadequateBarrierGroups?.filter((item) => item.idBarrier === 0)?.map((elem) => elem?.incidentBarrierGroup) || [],
			selectedItemsEBarrierHarm: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((elem) => elem?.incidentBarrier) || [],
			selectedItemsEBarrierEnv: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((elem) => elem?.incidentBarrier) || [],

			selectedItemsIBarrierGroupHarm: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentEffectiveInadequateBarrierGroups?.filter((item) => item.idBarrier === 1)?.map((elem) => elem?.incidentBarrierGroup) || [],
			selectedItemsIBarrierGroupEnv: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentEffectiveInadequateBarrierGroups?.filter((item) => item.idBarrier === 1)?.map((elem) => elem?.incidentBarrierGroup) || [],
			selectedItemsIBarrierHarm: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((elem) => elem?.incidentBarrier) || [],
			selectedItemsIBarrierEnv: this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((elem) => elem?.incidentBarrier) || [],
			})
		}
		//RITM1216061
		if (prevProps.appHighConsequenceLevels !== this.props.appHighConsequenceLevels) {
			this.getIncidentHighConsequenceLevel();
		}
		//End
	  }

	getIncidentHighConsequenceLevel = () => {
		const dataHighConsequenceLevelActualHarm = _sortBy(
			(this.props.appHighConsequenceLevels || []).filter((el) =>  (el.outcome == 0 && el.inUse) || this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.idHighConsequenceLevelActual == el.id), //RITM1216061
			'ranking'
		  );
		const dataHighConsequenceLevelPotentialWorstCaseHarm = _sortBy(
			(this.props.appHighConsequenceLevels || []).filter((el) =>  (el.outcome == 0 && el.inUse) || this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.idHighConsequenceLevelPotentialWorstCase == el.id), //RITM1216061
			'ranking'
		  );
		const dataHighConsequenceLevelPotentialFinalHarm = _sortBy(
			(this.props.appHighConsequenceLevels || []).filter((el) =>  (el.outcome == 0 && el.inUse) || this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.idHighConsequenceLevelPotentialFinal == el.id), //RITM1216061
			'ranking'
		  );
		const dataHighConsequenceLevelActualEnv = _sortBy(
			(this.props.appHighConsequenceLevels || []).filter((el) =>  (el.outcome == 2 && el.inUse) || this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.idHighConsequenceLevelActual == el.id), //RITM1216061
			'ranking'
		  );
		const dataHighConsequenceLevelPotentialWorstCaseEnv = _sortBy(
			(this.props.appHighConsequenceLevels || []).filter((el) =>  (el.outcome == 2 && el.inUse) || this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.idHighConsequenceLevelPotentialWorstCase == el.id), //RITM1216061
			'ranking'
		  );
		const dataHighConsequenceLevelPotentialFinalEnv = _sortBy(
			(this.props.appHighConsequenceLevels || []).filter((el) =>  (el.outcome == 2 && el.inUse) || this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.idHighConsequenceLevelPotentialFinal == el.id), //RITM1216061
			'ranking'
		  );
		this.setState({
			appHighConsequenceLevelActualHarm: dataHighConsequenceLevelActualHarm,
			appHighConsequenceLevelPotentialWorstCaseHarm: dataHighConsequenceLevelPotentialWorstCaseHarm,
			appHighConsequenceLevelPotentialFinalHarm: dataHighConsequenceLevelPotentialFinalHarm,
			appHighConsequenceLevelActualEnv: dataHighConsequenceLevelActualEnv,
			appHighConsequenceLevelPotentialWorstCaseEnv: dataHighConsequenceLevelPotentialWorstCaseEnv,
			appHighConsequenceLevelPotentialFinalEnv: dataHighConsequenceLevelPotentialFinalEnv,

		});
	}
	getIncidentEBarrierGroup = async () => {
		await dynamic
		  .getAll('incidentbarriergroup', { params: { page: 0 } })
		  .then((response) => {
			const dataEGroupHarm = _sortBy(
				(response.data.itemList || []).filter((el) =>  (el.inUse) 
					|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.id)),
				'ranking'
			  );
			const dataEGroupEnv = _sortBy(
				(response.data.itemList || []).filter((el) =>  (el.inUse) 
					|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.id)),
				'ranking'
			  );
			this.setState({
				appIncidentEBarrierGroupHarm: dataEGroupHarm,
				appIncidentEBarrierGroupEnv: dataEGroupEnv,
			});
		  })
		  .catch((error) => {
			showNotification.error(
			  `${entitiesLabels.ERROR}`,
			  getError(error, entitiesLabels.EFFECTIVEBARRIERGROUP, apioperation.GET)
			);
		  })
		  .finally(() => {});
	  }

	getIncidentIBarrierGroup = async () => {
		await dynamic
		  .getAll('incidentbarriergroup', { params: { page: 0 } })
		  .then((response) => {
			const dataIGroupHarm = _sortBy(
				(response.data.itemList || []).filter((el) =>  (el.inUse) 
					|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.id)),
				'ranking'
			  );
			const dataIGroupEnv = _sortBy(
				(response.data.itemList || []).filter((el) =>  (el.inUse) 
					|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.id)),
				'ranking'
			  );
			this.setState({
				appIncidentIBarrierGroupHarm: dataIGroupHarm,
				appIncidentIBarrierGroupEnv: dataIGroupEnv,
			});
		  })
		  .catch((error) => {
			showNotification.error(
			  `${entitiesLabels.ERROR}`,
			  getError(error, entitiesLabels.INADEQUATEBARRIERGROUP, apioperation.GET)
			);
		  })
		  .finally(() => {});
	  }
	
	getIncidentEBarrier = async (selectedBarrierGroups) => {
		await dynamic
		  .getAll('incidentbarrier', { params: { page: 0 } })
		  .then((response) => {
			if(selectedBarrierGroups == undefined)
			{
				const dataEHarm = _sortBy(
					(response.data.itemList || []).filter((el) => (selectedBarrierGroups != null 
						? selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup): true) && ((el.inUse && (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup)) 
						|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup))),
					[(p) => p.ranking, (p) => p.name?.toLowerCase()]
				  );
				const dataEEnv = _sortBy(
					(response.data.itemList || []).filter((el) => (selectedBarrierGroups != null 
						? selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup): true) && ((el.inUse && (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup)) 
						|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup))),
					[(p) => p.ranking, (p) => p.name?.toLowerCase()]
				  );
				this.setState({
					appIncidentEBarrierHarm: dataEHarm,
					appIncidentEBarrierEnv: dataEEnv,
				});
			}
			else
			{
				if (this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)
				{
					const dataEHarm = _sortBy(
						(response.data.itemList || []).filter((el) => (selectedBarrierGroups != null 
							? selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup): true) && ((el.inUse) 
							|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup && selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup)))),
						[(p) => p.ranking, (p) => p.name?.toLowerCase()]
					  );
					this.setState({
						appIncidentEBarrierHarm: dataEHarm,
						selectedItemsEBarrierHarm: this.state.selectedItemsEBarrierHarm.filter(x => selectedBarrierGroups.find(el => el.idIncidentBarrierGroup == x.idIncidentBarrierGroup)),
					});
				}
				else if(this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)
				{
					const dataEEnv = _sortBy(
						(response.data.itemList || []).filter((el) => (selectedBarrierGroups != null 
							? selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup): true) && ((el.inUse) 
							|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup && selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup)))),
						[(p) => p.ranking, (p) => p.name?.toLowerCase()]
					  );
					this.setState({
						appIncidentEBarrierEnv: dataEEnv,
						selectedItemsEBarrierEnv: this.state.selectedItemsEBarrierEnv.filter(x => selectedBarrierGroups.find(el => el.idIncidentBarrierGroup == x.idIncidentBarrierGroup)),
					});
				}
				else
				{
					this.setState({
						appIncidentEBarrierHarm: [],
						appIncidentEBarrierEnv: [],
					});
				}
			}
		  })
		  .catch((error) => {
			showNotification.error(
			  `${entitiesLabels.ERROR}`,
			  getError(error, entitiesLabels.EFFECTIVEBARRIER, apioperation.GET)
			);
		  })
		  .finally(() => {});
	  }
	getIncidentIBarrier = async (selectedBarrierGroups, idBarrier) => {
		await dynamic
		  .getAll('incidentbarrier', { params: { page: 0 } })
		  .then((response) => {
			if(selectedBarrierGroups == undefined)
			{
				const dataIHarm = _sortBy(
					(response.data.itemList || []).filter((el) => (selectedBarrierGroups != null 
						? selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup): true) && ((el.inUse && (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup)) 
						|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup))),
					[(p) => p.ranking, (p) => p.name?.toLowerCase()]
				  );
				const dataIEnv = _sortBy(
					(response.data.itemList || []).filter((el) => (selectedBarrierGroups != null 
						? selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup): true) && ((el.inUse && (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup)) 
						|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup))),
					[(p) => p.ranking, (p) => p.name?.toLowerCase()]
				  );
				this.setState({
					appIncidentIBarrierHarm: dataIHarm,
					appIncidentIBarrierEnv: dataIEnv,
				});
			}
			else
			{
				if (this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)
				{
					const dataIHarm = _sortBy(
						(response.data.itemList || []).filter((el) => (selectedBarrierGroups != null 
							? selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup): true) && ((el.inUse) 
							|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup && selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup)))),
						[(p) => p.ranking, (p) => p.name?.toLowerCase()]
					  );
					this.setState({
						appIncidentIBarrierHarm: dataIHarm,
						selectedItemsIBarrierHarm: this.state.selectedItemsIBarrierHarm.filter(x => selectedBarrierGroups.find(el => el.idIncidentBarrierGroup == x.idIncidentBarrierGroup)),
					});
				}
				else if(this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)
				{
					const dataIEnv = _sortBy(
						(response.data.itemList || []).filter((el) => (selectedBarrierGroups != null 
							? selectedBarrierGroups.find(x => x.idIncidentBarrierGroup == el.idIncidentBarrierGroup): true) && ((el.inUse) 
							|| (this.props.outcomeModel?.find(out => out.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.map((element) => element?.incidentBarrier?.incidentBarrierGroup) || []).find((elem) => elem.id === el.idIncidentBarrierGroup && selectedBarrierGroups.find(x => el.idIncidentBarrierGroup == x.idIncidentBarrierGroup)))),
						[(p) => p.ranking, (p) => p.name?.toLowerCase()]
					  );
					this.setState({
						appIncidentIBarrierEnv: dataIEnv,
						selectedItemsIBarrierEnv: this.state.selectedItemsIBarrierEnv.filter(x => selectedBarrierGroups.find(el => el.idIncidentBarrierGroup == x.idIncidentBarrierGroup)),
					});
				}
				else
				{
					this.setState({
						appIncidentIBarrierHarm: [],
						appIncidentIBarrierEnv: [],
					});
				}
			}
		  })
		  .catch((error) => {
			showNotification.error(
			  `${entitiesLabels.ERROR}`,
			  getError(error, entitiesLabels.INADEQUATEBARRIER, apioperation.GET)
			);
		  })
		  .finally(() => {});
	}
	/*NF ID: RITM1216061 || Task - 6 || Sub-Task-1  */
	// selectedPotentialFinal =async()=>{
	// 		if(this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome)
	// 		{
	// 			const selectedAHL= !this.props.realOutcomeHarm?0:this.state.appHighConsequenceLevelActualHarm
	// 			.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelActual) 
	// 			var selectedWCharm=	this.state.appHighConsequenceLevelPotentialWorstCaseHarm
	// 			.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialWorstCase)
	// 			this.setState({
	// 				selectedRankingHighConsequenceLevelActualHarm:!this.props.realOutcomeHarm?0:selectedAHL?.ranking,
	// 				selectedRankingHighConsequenceLevelActualWorstCaseHarm:selectedWCharm?.ranking,
	// 			})
	// 			const selectedPotentialFinalHarm=this.state.appHighConsequenceLevelPotentialFinalHarm
	// 			.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialFinal)
			
	// 			var potentialFinalRankingHarm= (selectedPotentialFinalHarm?.ranking);		
	// 			this.setState({
	// 			selectedRankingHighConsequenceLevelActualFinalHarm:potentialFinalRankingHarm,
	// 			selectedPotentialFinalHarmIsValid: (potentialFinalRankingHarm <=this.state.selectedRankingHighConsequenceLevelActualWorstCaseHarm) &&
	// 				(potentialFinalRankingHarm>=
	// 					this.state.selectedRankingHighConsequenceLevelActualHarm)?true:false,
	// 				})		

	// 		}
	// 		if(this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome)
	// 		{
	// 			const selectedAEL=	!this.props.realOutcomeEnvironmental?0:this.state.appHighConsequenceLevelActualEnv
	// 			.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelActual)
	// 			const selectedWCEnv=	this.state.appHighConsequenceLevelPotentialWorstCaseEnv
	// 			.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialWorstCase)
	// 			this.setState({
	// 				selectedRankingHighConsequenceLevelActualEnv:!this.props.realOutcomeEnvironmental?0:selectedAEL?.ranking,
	// 				selectedRankingHighConsequenceLevelActualWorstCaseEnv:selectedWCEnv?.ranking,
	// 				})		
				
	// 			const selectedPotentialFinalEnv=this.state.appHighConsequenceLevelPotentialFinalEnv
	// 			.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialFinal)
				
	// 			var potentialFinalRankingEnv= (selectedPotentialFinalEnv?.ranking);		
	// 			this.setState({
	// 				selectedRankingHighConsequenceLevelActualFinalEnv:potentialFinalRankingEnv,
	// 					})	
		
	// 		}	
	// }
	/*RITM1216061 end*/
	handleChangeCombo = (inputName, selectedItem, objName) => {
		const inputValue = selectedItem ? selectedItem.id : null;
		const s = inputName.split("_")	
		// RITM1216061 start
		if(s[1]=='0'){
			const  Actual= (inputName=='idHighConsequenceLevelActual_0')?(!this.props.realOutcomeHarm?0:this.state.appHighConsequenceLevelActualHarm.find((el) => el.id == selectedItem?.id)?.ranking)
			:(this.props.selectedOutcomeModel?.idHighConsequenceLevelActual != null ?this.state.appHighConsequenceLevelActualHarm.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelActual).ranking :null);
			const WC=(inputName=='idHighConsequenceLevelPotentialWorstCase_0')?this.state.appHighConsequenceLevelPotentialWorstCaseHarm.find((el) => el.id == selectedItem?.id)?.ranking                       
			:(this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialWorstCase != null?this.state.appHighConsequenceLevelPotentialWorstCaseHarm.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialWorstCase).ranking:null);
			const Final=(inputName=='idHighConsequenceLevelPotentialFinal_0')?this.state.appHighConsequenceLevelPotentialFinalHarm.find((el) => el.id == selectedItem?.id)?.ranking          
			:(this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialFinal != null?this.state.appHighConsequenceLevelPotentialFinalHarm
			.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialFinal).ranking:null);
			// this.setState((prevState) => ({
			// 	selectedRankingHighConsequenceLevelActualHarm:Actual,
			// 	selectedRankingHighConsequenceLevelActualWorstCaseHarm: WC, 
			// 	selectedRankingHighConsequenceLevelActualFinalHarm: Final,})
			// );
			
			this.props.handleHighConsequenceLevel(inputValue, s[0], this.props.selectedOutcomeModel?.idOutcome,Actual,WC,Final);
		}
		if(s[1]=='2'){
			const  Actual= (inputName=='idHighConsequenceLevelActual_2')?(!this.props.realOutcomeEnvironmental?0:this.state.appHighConsequenceLevelActualEnv.find((el) => el.id == selectedItem?.id)?.ranking)
			:(this.props.selectedOutcomeModel?.idHighConsequenceLevelActual != null ?this.state.appHighConsequenceLevelActualEnv.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelActual).ranking :null);
			const WC=(inputName=='idHighConsequenceLevelPotentialWorstCase_2')?this.state.appHighConsequenceLevelPotentialWorstCaseEnv.find((el) => el.id == selectedItem?.id)?.ranking                       
			:(this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialWorstCase != null?this.state.appHighConsequenceLevelPotentialWorstCaseEnv.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialWorstCase).ranking:null);
			const Final=(inputName=='idHighConsequenceLevelPotentialFinal_2')?this.state.appHighConsequenceLevelPotentialFinalEnv.find((el) => el.id == selectedItem?.id)?.ranking          
			:(this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialFinal != null?this.state.appHighConsequenceLevelPotentialFinalEnv
			.find((el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialFinal).ranking:null);
			
			// this.setState((prevState) => ({
			// 	selectedRankingHighConsequenceLevelActualEnv:Actual,
			// 	selectedRankingHighConsequenceLevelActualWorstCaseEnv: WC, 
			// 	selectedRankingHighConsequenceLevelActualFinalEnv: Final,})
			// );
			this.props.handleHighConsequenceLevel(inputValue, s[0], this.props.selectedOutcomeModel?.idOutcome,Actual,WC,Final);
		}
		//RITM1216061 end
	  };
	 
	onChangeEBarrierGroup = (selectedItem) => {
		const items = selectedItem ? selectedItem.selectedItems : null;
		this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome
		? (this.setState({
			selectedItemsEBarrierGroupHarm: items,
		  })) 
		: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome 
		? this.setState({
			selectedItemsEBarrierGroupEnv: items,
		  })
		: this.setState({
			selectedItemsEBarrierGroupHarm: [],
			selectedItemsEBarrierGroupEnv: [],
		  })
		this.getIncidentEBarrier(items?.map((elem) =>({idIncidentBarrierGroup: elem.id})));
		const element = items?.map((elem) =>({incidentBarrierGroup: elem, idBarrier: 0}))
		this.props.handleIncidentOutcomeBarrier(element, "incidentEffectiveInadequateBarrierGroups", this.props.selectedOutcomeModel?.idOutcome, 0);
	  };

	onChangeEBarrier = (selectedItem) => {
		const items = selectedItem ? selectedItem.selectedItems : null;
		this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome 
		? (this.setState({
			selectedItemsEBarrierHarm: items,
			//appIncidentEBarrierGroupHarm: this.state.appIncidentEBarrierGroupHarm.filter(x => items.find(el => el.idIncidentBarrierGroup == x.id)),
			selectedItemsEBarrierGroupHarm: this.state.selectedItemsEBarrierGroupHarm.filter(x => items.find(el => el.idIncidentBarrierGroup == x.id)),
		  })) 
		: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome 
		? this.setState({
			selectedItemsEBarrierEnv: items,
			//appIncidentEBarrierGroupEnv: this.state.appIncidentEBarrierGroupEnv.filter(x => items.find(el => el.idIncidentBarrierGroup == x.id)),
			selectedItemsEBarrierGroupEnv: this.state.selectedItemsEBarrierGroupEnv.filter(x => items.find(el => el.idIncidentBarrierGroup == x.id)),
		  })
		: this.setState({
			selectedItemsEBarrierHarm: [],
			selectedItemsEBarrierEnv: [],
		  })
		this.getIncidentEBarrier(items?.map((elem) =>({idIncidentBarrierGroup: elem.idIncidentBarrierGroup})));
		const element = items?.map((elem) =>({incidentBarrier: elem, idBarrier: 0}))
		// const effectiveInadequateBarrierGroupElement = this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome 
		// 		? this.state.selectedItemsEBarrierGroupHarm?.map((elem) =>({incidentBarrierGroup: elem, idBarrier: 0})) 
		// 		: this.state.selectedItemsEBarrierGroupEnv?.map((elem) =>({incidentBarrierGroup: elem, idBarrier: 0})) 
		this.props.handleIncidentOutcomeBarrier(element, "incidentBarriers", this.props.selectedOutcomeModel?.idOutcome, 0);
	  };

	onChangeIBarrierGroup = (selectedItem) => {
		const items = selectedItem ? selectedItem.selectedItems : null;
		this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome 
		? (this.setState({
			selectedItemsIBarrierGroupHarm: items,
		  })) 
		: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome 
		? this.setState({
			selectedItemsIBarrierGroupEnv: items,
		  })
		: this.setState({
			selectedItemsIBarrierGroupHarm: [],
			selectedItemsIBarrierGroupEnv: [],
		  })
		this.getIncidentIBarrier(items?.map((elem) =>({idIncidentBarrierGroup: elem.id})));
		const element = items?.map((elem) =>({incidentBarrierGroup: elem, idBarrier: 1}))
		this.props.handleIncidentOutcomeBarrier(element, "incidentEffectiveInadequateBarrierGroups", this.props.selectedOutcomeModel?.idOutcome, 1);
	  };
	  
	onChangeIBarrier = (selectedItem) => {
		const items = selectedItem ? selectedItem.selectedItems : null;
		this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome 
		? (this.setState({
			selectedItemsIBarrierHarm: items,
			//appIncidentIBarrierGroupHarm: this.state.appIncidentIBarrierGroupHarm.filter(x => items.find(el => el.idIncidentBarrierGroup == x.id)),
			selectedItemsIBarrierGroupHarm: this.state.selectedItemsIBarrierGroupHarm.filter(x => items.find(el => el.idIncidentBarrierGroup == x.id)),
		  })) 
		: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome 
		? this.setState({
			selectedItemsIBarrierEnv: items,
			//appIncidentIBarrierGroupEnv: this.state.appIncidentIBarrierGroupEnv.filter(x => items.find(el => el.idIncidentBarrierGroup == x.id)),
			selectedItemsIBarrierGroupEnv: this.state.selectedItemsIBarrierGroupEnv.filter(x => items.find(el => el.idIncidentBarrierGroup == x.id)),
		  })
		: this.setState({
			selectedItemsIBarrierHarm: [],
			selectedItemsIBarrierEnv: [],
		  })
		this.getIncidentIBarrier(items?.map((elem) =>({idIncidentBarrierGroup: elem.idIncidentBarrierGroup})));
		const element = items?.map((elem) =>({incidentBarrier: elem, idBarrier: 1}))
		// const effectiveInadequateBarrierGroupElement = this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome 
		// 		? this.state.selectedItemsIBarrierGroupHarm?.map((elem) =>({incidentBarrierGroup: elem, idBarrier: 1})) 
		// 		: this.state.selectedItemsIBarrierGroupEnv?.map((elem) =>({incidentBarrierGroup: elem, idBarrier: 1})) 
		this.props.handleIncidentOutcomeBarrier(element, "incidentBarriers", this.props.selectedOutcomeModel?.idOutcome, 1);
	  };

	returnIncidentBarriers = (id, property) =>	{
			if(property === "EBarrierGroup") 
			{
				return this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome 
				? (this.state.selectedItemsEBarrierGroupHarm?.find(el => el.id === id) ? true : false)
				: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome
				? (this.state.selectedItemsEBarrierGroupEnv?.find(el => el.id === id) ? true : false)
				: false
			}
			else if (property === "EBarrier")
			{
				return this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome 
				? (this.state.selectedItemsEBarrierHarm?.find(el => el.id === id) ? true : false)
				: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome
				? (this.state.selectedItemsEBarrierEnv?.find(el => el.id === id) ? true : false)
				: false
			}
			else if(property === "IBarrierGroup") 
			{
				return this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome 
				? (this.state.selectedItemsIBarrierGroupHarm?.find(el => el.id === id) ? true : false)
				: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome
				? (this.state.selectedItemsIBarrierGroupEnv?.find(el => el.id === id) ? true : false)
				: false
			}
			else if (property === "IBarrier")
			{
				return this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome 
				? (this.state.selectedItemsIBarrierHarm?.find(el => el.id === id) ? true : false)
				: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome
				? (this.state.selectedItemsIBarrierEnv?.find(el => el.id === id) ? true : false)
				: false
			}
		}
	
	render() {
			return (				
					<>
						<div className="bx--grid--full-width">
							<div className="bx--row">
								<div className="bx--col-md-4 bx--col-lg-6">
									<FormGroup legendText={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? "AHC_people (Actual High Consequence Level on People)*" : "AHC_env (Actual High Consequence Level on Environment)*"}> {/*RITM1216061*/}
										<ComboBox
												id={"idHighConsequenceLevelActual_" + this.props.selectedOutcomeModel?.idOutcome}
												key={"idHighConsequenceLevelActual_" + this.props.selectedOutcomeModel?.idOutcome}
												placeholder="Select"
												name={"idHighConsequenceLevelActual_" + this.props.selectedOutcomeModel?.idOutcome}
												alt="model"												
												onChange={this.handleChangeCombo}
												itemToString={(item) => (item ? item.name : "")}
											items={((this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? 
											(this.state.appHighConsequenceLevelActualHarm) : (this.state.appHighConsequenceLevelActualEnv)))}//RITM1216061 
											selectedItem={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ?
											((this.props.realOutcomeHarm !== null && this.props.realOutcomeHarm == false) ? this.state.appHighConsequenceLevelActualHarm[0]:(this.state.appHighConsequenceLevelActualHarm.find(
											(el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelActual)) || [])
											:((this.props.realOutcomeEnvironmental !== null && this.props.realOutcomeEnvironmental == false) ? this.state.appHighConsequenceLevelActualEnv[0] :(this.state.appHighConsequenceLevelActualEnv.find(
												(el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelActual)) || [])} //RITM1216061 

											disabled={this.props.isDisabled || (this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? !this.props.realOutcomeHarm : !this.props.realOutcomeEnvironmental)} //RITM1216061 
											invalid={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.highConsequenceLevelActualHarm != null : this.props.validations.highConsequenceLevelActualEnv != null}
											invalidText={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.highConsequenceLevelActualHarm : this.props.validations.highConsequenceLevelActualEnv}
										/>
									</FormGroup>
								</div>
								<div className="bx--col-md-4 bx--col-lg-6">
									<FormGroup legendText={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? " PHCwc_people (Potential High Consequence Level Worst Case on People)*" : "PHCwc_env (Potential High Consequence Level Worst Case on Environment)*"}> {/*RITM1216061*/}
										<ComboBox
												id={"idHighConsequenceLevelPotentialWorstCase_" + this.props.selectedOutcomeModel?.idOutcome}
												key={"idHighConsequenceLevelPotentialWorstCase_" + this.props.selectedOutcomeModel?.idOutcome}
												placeholder="Select"
												name={"idHighConsequenceLevelPotentialWorstCase_" + this.props.selectedOutcomeModel?.idOutcome}
												alt="model"
												onChange={this.handleChangeCombo}
												itemToString={(item) => (item ? item.name : "")}
												items={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appHighConsequenceLevelPotentialWorstCaseHarm : this.state.appHighConsequenceLevelPotentialWorstCaseEnv}
												selectedItem={((this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appHighConsequenceLevelPotentialWorstCaseHarm : this.state.appHighConsequenceLevelPotentialWorstCaseEnv) || []).find(
													(el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialWorstCase
												)}
												disabled={this.props.isDisabled}
												invalid={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.highConsequenceLevelPotentialWorstCaseHarm != null : this.props.validations.highConsequenceLevelPotentialWorstCaseEnv != null}
												invalidText={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.highConsequenceLevelPotentialWorstCaseHarm : this.props.validations.highConsequenceLevelPotentialWorstCaseEnv}
										/>
									</FormGroup>
								</div>
								<div className="bx--col-md-4 bx--col-lg-6">
									<FormGroup legendText="Effective Barrier Groups*">
										{this.state.loading ? (
											<DropdownSkeleton />
											) : (
												<MultiSelect.Filterable
														id={"effectiveBarrierGroup_" + this.props.selectedOutcomeModel?.idOutcome}
														key={"effectiveBarrierGroup_" + this.props.selectedOutcomeModel?.idOutcome + Math.random()}
														invalid={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.effectiveBarrierGroupHarm != null : this.props.validations.effectiveBarrierGroupEnv != null}
														invalidText={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.effectiveBarrierGroupHarm : this.props.validations.effectiveBarrierGroupEnv}
														disabled={this.props.isDisabled}
														placeholder={
															(this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? (this.state.selectedItemsEBarrierGroupHarm < 1 
															? 'Choose one or more effective barrier groups'
															: this.state.selectedItemsEBarrierGroupHarm.map((el) => el.name).join(', '))
															: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome ? (this.state.selectedItemsEBarrierGroupEnv < 1 
															? 'Choose one or more effective barrier groups'
															: this.state.selectedItemsEBarrierGroupEnv.map((el) => el.name).join(', '))
															: '')
														}
														itemToString={(item) => (item ? item && item.name : '')}
														items={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appIncidentEBarrierGroupHarm : this.state.appIncidentEBarrierGroupEnv }
														light={false}
														onChange={this.onChangeEBarrierGroup}
														type="default"
														sortItems={(items) => items}
														initialSelectedItems ={((this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appIncidentEBarrierGroupHarm : this.state.appIncidentEBarrierGroupEnv) || []).filter((el) => this.returnIncidentBarriers(el.id, "EBarrierGroup"))}
												/>
										)} 
									</FormGroup>
								</div>
								<div className="bx--col-md-4 bx--col-lg-6">
									<FormGroup legendText="Effective Barriers*">
									{this.state.loading ? (
											<DropdownSkeleton />
											) : (
												<MultiSelect.Filterable
														id={"effectiveBarrier_" + this.props.selectedOutcomeModel?.idOutcome}
														key={"effectiveBarrier_" + this.props.selectedOutcomeModel?.idOutcome + Math.random()}
					
														invalid={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.effectiveBarrierHarm != null : this.props.validations.effectiveBarrierEnv != null}
														invalidText={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.effectiveBarrierHarm : this.props.validations.effectiveBarrierEnv}
														disabled={(this.props.isDisabled && this.props.selectedOutcomeModel?.incidentBarriers?.filter((item) => item.idBarrier === 0)?.length < 1) 
															|| (this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome
															? this.state.selectedItemsEBarrierGroupHarm < 1 : this.state.selectedItemsEBarrierGroupEnv < 1)}
														placeholder={
															(this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? (this.state.selectedItemsEBarrierHarm < 1 
															? 'Choose one or more effective barriers'
															: this.state.selectedItemsEBarrierHarm.map((el) => el.name).join(', '))
															: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome ? (this.state.selectedItemsEBarrierEnv < 1 
															? 'Choose one or more effective barriers'
															: this.state.selectedItemsEBarrierEnv.map((el) => el.name).join(', '))
															: '')
														}
														itemToString={(item) => (item ? item && item.name : '')}
														items={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appIncidentEBarrierHarm: this.state.appIncidentEBarrierEnv}
														light={false}
														onChange={this.onChangeEBarrier}
														type="default"
														sortItems={(items) => items}
														initialSelectedItems ={((this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appIncidentEBarrierHarm: this.state.appIncidentEBarrierEnv) || []).filter((e) => this.returnIncidentBarriers(e.id, "EBarrier"))}
													/>
											)} 
									</FormGroup>
								</div>
								<div className="bx--col-md-4 bx--col-lg-6">
									<FormGroup legendText="Inadequate Barrier Groups*">
										{this.state.loading ? (
												<DropdownSkeleton />
												) : (
													<MultiSelect.Filterable
															id={"inadequateBarrierGroup_" + this.props.selectedOutcomeModel?.idOutcome}
															key={"inadequateBarrierGroup_" + this.props.selectedOutcomeModel?.idOutcome + Math.random()}
															invalid={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.inadequateBarrierGroupHarm != null : this.props.validations.inadequateBarrierGroupEnv != null}
															invalidText={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.inadequateBarrierGroupHarm : this.props.validations.inadequateBarrierGroupEnv}
															disabled={this.props.isDisabled}
															placeholder={
																(this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? (this.state.selectedItemsIBarrierGroupHarm < 1 
																? 'Choose one or more inadequate barrier groups'
																: this.state.selectedItemsIBarrierGroupHarm.map((el) => el.name).join(', '))
																: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome ? (this.state.selectedItemsIBarrierGroupEnv < 1 
																? 'Choose one or more inadequate barrier groups'
																: this.state.selectedItemsIBarrierGroupEnv.map((el) => el.name).join(', '))
																: '')
															}
															itemToString={(item) => (item ? item && item.name : '')}
															items={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appIncidentIBarrierGroupHarm : this.state.appIncidentIBarrierGroupEnv}
															light={false}
															onChange={this.onChangeIBarrierGroup}
															type="default"
															sortItems={(items) => items}
															initialSelectedItems ={((this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appIncidentIBarrierGroupHarm : this.state.appIncidentIBarrierGroupEnv) || []).filter((el) => this.returnIncidentBarriers(el.id, "IBarrierGroup"))}
													/>
											)} 
									</FormGroup>
								</div>
								<div className="bx--col-md-4 bx--col-lg-6">
									<FormGroup legendText="Inadequate Barriers*">
										{this.state.loading ? (
													<DropdownSkeleton />
													) : (
														<MultiSelect.Filterable
																id={"inadequateBarrier_" + this.props.selectedOutcomeModel?.idOutcome}
																key={"inadequateBarrier_" + this.props.selectedOutcomeModel?.idOutcome + Math.random()}
																invalid={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.inadequateBarrierHarm != null : this.props.validations.inadequateBarrierEnv != null}
																invalidText={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.inadequateBarrierHarm : this.props.validations.inadequateBarrierEnv}
																disabled={(this.props.isDisabled && this.props.selectedOutcomeModel?.incidentBarriers?.filter((item) => item.idBarrier === 1)?.length < 1) 
																	|| (this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome
																	? this.state.selectedItemsIBarrierGroupHarm < 1 : this.state.selectedItemsIBarrierGroupEnv < 1)}
																placeholder={
																	(this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? (this.state.selectedItemsIBarrierHarm < 1 
																	? 'Choose one or more inadequate barriers'
																	: this.state.selectedItemsIBarrierHarm.map((el) => el.name).join(', '))
																	: this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeEnvironmental"].idOutcome ? (this.state.selectedItemsIBarrierEnv < 1 
																	? 'Choose one or more inadequate barriers'
																	: this.state.selectedItemsIBarrierEnv.map((el) => el.name).join(', '))
																	: '')
																}
																itemToString={(item) => (item ? item && item.name : '')}
																items={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appIncidentIBarrierHarm: this.state.appIncidentIBarrierEnv}
																light={false}
																onChange={this.onChangeIBarrier}
																type="default"
																sortItems={(items) => items}
																initialSelectedItems ={((this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appIncidentIBarrierHarm: this.state.appIncidentIBarrierEnv) || []).filter((e) => this.returnIncidentBarriers(e.id, "IBarrier"))}
														/>
												)}
									</FormGroup>
								</div>
								<div className="bx--col-md-4 bx--col-lg-6">
									<FormGroup legendText={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? "PHCf_people (Potential High Consequence Level Final on People)*" : "PHCf_env (Potential High Consequence Level Final on Environment)*"}> {/*RITM1216061*/}
										<ComboBox
												id={"idHighConsequenceLevelPotentialFinal_" + this.props.selectedOutcomeModel?.idOutcome}
												key={"idHighConsequenceLevelPotentialFinal_" + this.props.selectedOutcomeModel?.idOutcome}
												placeholder="Select"
												name={"idHighConsequenceLevelPotentialFinal_" + this.props.selectedOutcomeModel?.idOutcome}
												alt="model"
												onChange={this.handleChangeCombo}
												itemToString={(item) => (item ? item.name : "")}
												items={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appHighConsequenceLevelPotentialFinalHarm : this.state.appHighConsequenceLevelPotentialFinalEnv}
												selectedItem={((this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.state.appHighConsequenceLevelPotentialFinalHarm : this.state.appHighConsequenceLevelPotentialFinalEnv) || []).find(
													(el) => el.id == this.props.selectedOutcomeModel?.idHighConsequenceLevelPotentialFinal
												)}
											disabled={this.props.isDisabled}
											invalid={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.highConsequenceLevelPotentialFinalHarm != null : this.props.validations.highConsequenceLevelPotentialFinalEnv != null}
											invalidText={this.props.selectedOutcomeModel?.idOutcome === this.state.incidentOutcomesEnums["outcomeHarm"].idOutcome ? this.props.validations.highConsequenceLevelPotentialFinalHarm : this.props.validations.highConsequenceLevelPotentialFinalEnv}
										/>
									</FormGroup> 
								</div>
								<div className="bx--col-lg-12 bx--col-md-12 ">
									<HighConsequenceLevelLegend />
								</div>
							</div>
						</div>
					</>	
			    );
			}
		}


IncidentHighConsequence.propTypes = {
	invalid: PropTypes.bool,
	invalidText: PropTypes.string,
	section: PropTypes.string,
	loadAll: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	onError: PropTypes.func.isRequired,
	initialSelectedItems: PropTypes.array,
	disabled: PropTypes.bool,
  };
IncidentHighConsequence.defaultProps = {
	invalid: false,
	invalidText: '',
	section: null,
	loadAll: false,
	initialSelectedItems: [],
	disabled: true,
  };
export default IncidentHighConsequence;
